import type {UserData} from "~/types/UserData";

export function userHasRole(user: UserData, roleName: string) {
    if (!Array.isArray(user.roles)) {
        return false;
    }

    return user.roles.some((role: { name: string }) => role.name === roleName);
}
